import React from 'react';
import { useGeoPrice } from '../lib/pricing';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = ''
}: PriceDisplayProps) {
  const {
    formatPrice,
    convertFromUSD,
    convertCompareFromUSD
  } = useGeoPrice();
  const localAmount = convertFromUSD(amount);
  const localOriginal = originalAmount ? convertCompareFromUSD(originalAmount) : undefined;
  // Single price (no compare-at) — render inline as before
  if (localOriginal == null) {
    return <span className={`whitespace-nowrap ${className}`} data-id="element-155">
        {formatPrice(localAmount)}
      </span>;
  }
  // Stacked layout: compare-at on top, current price below
  return <span className={`flex flex-col items-center gap-0 ${className}`} data-id="element-156">
      <span className="text-gray-500 line-through decoration-red-500/50 decoration-2 whitespace-nowrap" style={{
      fontSize: '0.45em'
    }} data-id="element-157">
        {formatPrice(localOriginal)}
      </span>
      <span className="whitespace-nowrap leading-tight" data-id="element-158">
        {formatPrice(localAmount)}
      </span>
    </span>;
}